import { connect } from "react-redux";
import Branch_manage from "../Components/assignpermission/branchmanagment";
import { Settablehistory } from "../Service/Actions/action";

const dispatchpart = (dispatch) => ({
  Settable_history: (data) => dispatch(Settablehistory(data)),
});

const getpart = (state) => ({
  state,
});

export default connect(getpart, dispatchpart)(Branch_manage);
